export default __webpack_public_path__ + "static/media/logo.6a91a0e2.png";